import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-service-plan',
  standalone: true,
  imports: [CommonModule,RouterModule],
  templateUrl: './service-plan.component.html',
  styleUrl: './service-plan.component.scss'
})
export class ServicePlanComponent {

}
